import { Fade } from '@mui/material';
import React, { FC } from 'react';
import { OrderManagementDetail } from '..';
import { Modal } from '../../../components';

interface IPartsHistoryOrderModal {
  open: boolean;
  onClose: (val?: string) => void;
  fieldOrderId: string;
}

export const PartsHistoryOrderModal: FC<IPartsHistoryOrderModal> = ({ open, onClose, fieldOrderId }) => {
  return (
    <Modal open={open} showClose={true} onClose={onClose} maxWidth="lg">
      <Fade in={open}>
        <div>
          <OrderManagementDetail isModal={true} orderId={fieldOrderId} isPartsHistory={true} />
        </div>
      </Fade>
    </Modal>
  );
};
